import { useCallback, useEffect, useState } from "react"
import { User, getUser } from "./api"

export const LoadingScreen = ({
  onNotLoggedIn,
  onLoggedIn,
}: {
  onNotLoggedIn: () => void
  onLoggedIn: (loggedInUser: User) => void
}) => {
  const [error, setError] = useState<string>()

  const loadUser = useCallback(async () => {
    try {
      const loggedInUser = await getUser()
      if (loggedInUser === undefined) {
        onNotLoggedIn()
      } else {
        onLoggedIn(loggedInUser)
      }
    } catch (error) {
      setError("Something went wrong, please try again.")
    }
  }, [onNotLoggedIn, onLoggedIn])

  useEffect(() => {
    loadUser()
  }, [loadUser])

  return (
    <div className="Loading">
      {error !== undefined && <p className="App-api-error">{error}</p>}
      <div className="loader" data-testid="loader" />
    </div>
  )
}
